import ajax from "../http.js";
import { EventEmitter } from "events";

class ReportService extends EventEmitter {
  constructor() {
    super();
  }

  /**
   * Method to get all report types: POST
   */
  getAllReports() {
    return new Promise((resolve, reject) => {
      ajax
        .get(`/Reports/ReportTypes/All`)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          resolve(error);
        });
    });
  }

  /**
   * Method to create new report: POST
   */
  createReport(data) {
    return new Promise((resolve, reject) => {
      ajax
        .post(`/Reports`, data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          resolve(error.response);
        });
    });
  }

  /**
   * Method to download report: GET
   */
  getReport(id) {
    return new Promise((resolve, reject) => {
      ajax
        .get(`/Reports/GetPDFReport?reportId=${id}`, {
          responseType: "arraybuffer"
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          resolve(error);
        });
    });
  }

  /**
   * Method to download all reports for user: GET
   */
  getReportsForUser() {
    return new Promise((resolve, reject) => {
      ajax
        .get(`/Reports/User`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          resolve(error);
        });
    });
  }

  /**
   * Method to download all reports for user: GET
   */
  getReportsCSV(start, end) {
    let url = `/Reports/All/Csv`;
    if (start) {
      url += `?start=${start}&end=${end}`;
    }
    return new Promise((resolve, reject) => {
      ajax
        .get(url, {
          responseType: "blob"
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          resolve(error);
        });
    });
  }
}

const reportService = new ReportService();

reportService.setMaxListeners(5);

export default reportService;
